<template>
	<div>
		<div class="section-title is-small">
			Imprint
		</div>
		<h2>RediR™</h2>
		<p>
			<br>
			Information according to §5 TMG:
			<br><br>
			Sunlab GmbH<br>
			Bamberger Str. 9<br>
			63743 Aschaffenburg<br>
			Germany
			<br><br>
			Managing Director: Andreas Kraus
			<br><br>
			E-Mail: support@redir.love<br>
			Internet: https://www.sunlab.de
			<br><br>
			Register court: Amtsgericht Aschaffenburg<br>
			Registration number: HRB 11563
			<br><br>
			DE 276707924
		</p>
	</div>
</template>

<script>
export default {
	name: 'Impressum',
};
</script>

<style lang="scss" scoped>
h2 {
	font-size: $size-5;
	font-weight: $fontWeight-medium;
	color: $color-white;
	margin-top: $gap-2;
}

h3 {
	font-size: $size-6;
	font-weight: $fontWeight-medium;
	color: $color-white;
	margin-top: $gap-2;
}

p,
li {
	font-size: $size-7;
	font-weight: $fontWeight-regular;
	color: $color-accent-100;
	line-height: $lineHeight-medium;
	margin-top: $gap-1;
}
</style>
